import { render } from "./StakingModal.vue?vue&type=template&id=622b08cf&scoped=true"
import script from "./StakingModal.vue?vue&type=script&lang=js"
export * from "./StakingModal.vue?vue&type=script&lang=js"

import "./StakingModal.vue?vue&type=style&index=0&id=622b08cf&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/wildwestgame/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622b08cf"]])

export default __exports__